import { useRouter } from 'vue-router'

export interface UseOrderRouter {
  navToMainPage: () => Promise<void>
  navToDetailPage: (
    orderId: string,
    returnTo?: string,
    returnToId?: string
  ) => Promise<void>
}

export const ORDER_PREFIX = 'brand.orders'

export const useOrderRouter = (): UseOrderRouter => {
  const router = useRouter()

  const navToMainPage = async (): Promise<void> => {
    await router.push({
      name: ORDER_PREFIX,
    })
  }

  const navToDetailPage = async (
    orderId: string,
    returnTo?: string,
    returnToId?: string
  ): Promise<void> => {
    await router.push({
      name: `${ORDER_PREFIX}.detail`,
      params: {
        orderId,
      },
      query: {
        returnTo,
        returnToId,
      },
    })
  }

  return {
    navToDetailPage,
    navToMainPage,
  }
}
